import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { Cbo } from 'src/app/core/cbo';
import { CboService } from 'src/app/services/cbo/cbo.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'cadastrar-cbo',
  templateUrl: './cadastrar-cbo.component.html',
  styleUrls: ['./cadastrar-cbo.component.css']
})
export class CadastrarCboComponent implements OnInit {

  cbo: Cbo = new Cbo();

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  mostrarBotaoCadastrar = true;
  mostrarBotaoAtualizar = true;

  isAtualizar = false;

  public maskNumeroCBO  = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/];

  constructor(
    private cboService: CboService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastService: ToastService
  ) { }


  ngOnInit() {

    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    if (!this.perfilAcesso.insere) {
      this.mostrarBotaoCadastrar = false;
    }

    if (!this.perfilAcesso.altera) {
      this.mostrarBotaoAtualizar = false;
    }


    let id: number;
    id = this.activatedRoute.snapshot.queryParams.id ? this.activatedRoute.snapshot.queryParams.id : null;
    if (id) {
      this.isAtualizar = true;
      this.cboService.getById(id).subscribe((cbo: Cbo) => {
        this.cbo = cbo;
        this.cbo.numero = this.cbo.numero.replace(/(\d{5})(\d{1})/, '$1-$2');
      });
    }

  }
  
  mostrarBotaoLimpar(){
    if (this.isAtualizar)  { return false; }
    if (!this.mostrarBotaoAtualizar) { return false; }
    if (!this.mostrarBotaoCadastrar) { return false; }

    return true;
  }


  cadastrar() {
    this.cboService.cadastrar(this.cbo).subscribe(() => {
      this.router.navigate(['cbo']);
      this.toastService.showSucesso('CBO cadastradO com sucesso');
    });
  }

  limpar() {
    this.cbo = new Cbo();
  }

  cancelar() {
    this.router.navigate(['cbo']);
  }


  atualizar() {
    this.cboService.alterar(this.cbo).subscribe(() => {
      this.router.navigate(['cbo']);
      this.toastService.showSucesso('CBO atualizado com sucesso');
    });

  }


}
